import script from "./PhotoBooth.vue?vue&type=script&setup=true&lang=js"
export * from "./PhotoBooth.vue?vue&type=script&setup=true&lang=js"

import "./PhotoBooth.vue?vue&type=style&index=0&id=24169e09&lang=css"

const __exports__ = script;

export default __exports__